
import { IUpdateSclaSchool, SclaApplication } from 'features/scla/types';
import { makePutRequest } from 'lib/axios';

const updateSclaAppSchool = async (
  id: string,
  payload: IUpdateSclaSchool,
): Promise<SclaApplication> => {
  const url = `/scla/application/school/${id}`;
  const response = await makePutRequest(url, payload);
  return response.data.payload;
};

export default updateSclaAppSchool;
